import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {checkNiudStatus, setFormErrors, clearApiError, resetState} from './BusinessCheckNiudStatusSlice';
import {validateInput, TextInputEnum} from '../../../utilities/validation/InputValidation';
import {getContactOrgId} from '../BusinessActivateNiudBlock/constants';
import {getContactCompanyList} from '../PortalsBlock/portalSlice';
import {formatRequestedPortTime} from './constants';
import NiudNumberSection from './components/NiudNumberSection';
import CheckNiudStatusResultMessage from './components/CheckNiudStatusResultMessage';
import './BusinessCheckNiudStatusMain.scss';

const BusinessCheckNiudStatusMain = ({
  iContent,
  formErrors,
  apiError,
  apiErrorMessage,
  requestedPortTime,
  statusMessage,
  statusType,
  checkNiudStatus,
  setFormErrors,
  clearApiError,
  resetState,
  contactOrgId,
  isFullAuthenticated,
  isCompanyListReqCompleted,
  isLoading,
  getContactCompanyList,
}) => {
  const [form, setForm] = useState({
    niudNumber: '',
  });

  useEffect(() => {
    return () => resetState();
  }, []);

  useEffect(() => {
    if (isFullAuthenticated && !isLoading && !isCompanyListReqCompleted) {
      getContactCompanyList();
    }
  }, [isFullAuthenticated]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFieldChange = (field, value) => {
    clearApiError();
    setForm((prev) => ({...prev, [field]: value}));
    if (formErrors[field]) {
      setFormErrors({...formErrors, [field]: ''});
    }
  };

  const handlePhoneChange = (field, e) => {
    const currentItem = e.nativeEvent?.data;
    const regex = /^\d+$/;
    if (regex.test(currentItem) || !e.nativeEvent?.data) {
      handleFieldChange(field, e.target.value);
    }
  };

  const handleCheckStatus = async () => {
    const niudNumberError = validateInput(form.niudNumber, TextInputEnum.Phone);
    if (niudNumberError) {
      setFormErrors({niudNumber: niudNumberError});
      return;
    }

    setFormErrors({});
    await checkNiudStatus({
      ...form,
      contactOrgId,
    });
  };

  const checkButtonText = iContent?.checkButtonText?.value || 'בצע בדיקה';
  const title = iContent?.title?.value;
  const boldTitle = iContent?.boldTitle?.value;
  const formattedPortTime = formatRequestedPortTime(requestedPortTime);

  return (
    <div className='businessCheckNiudStatus'>
      <div className='check-niud-status-step'>
        {title && <div className='L_Title'>{title}</div>}
        {boldTitle && <div className='M_Sub_Title center'>{boldTitle}</div>}

        <NiudNumberSection form={form} formErrors={formErrors} onPhoneChange={handlePhoneChange} />

        <CheckNiudStatusResultMessage
          apiError={apiError}
          apiErrorMessage={apiErrorMessage}
          statusType={statusType}
          statusMessage={statusMessage}
          requestedPortTime={requestedPortTime}
          formattedPortTime={formattedPortTime}
        />

        <div className='continue-button'>
          <BtnSubmit isBusiness text={checkButtonText} onclick={handleCheckStatus} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  formErrors: state.BusinessCheckNiudStatusSlice?.formErrors || {},
  apiError: state.BusinessCheckNiudStatusSlice?.apiError,
  apiErrorMessage: state.BusinessCheckNiudStatusSlice?.apiErrorMessage,
  requestedPortTime: state.BusinessCheckNiudStatusSlice?.requestedPortTime,
  statusMessage: state.BusinessCheckNiudStatusSlice?.statusMessage,
  statusType: state.BusinessCheckNiudStatusSlice?.statusType,
  contactOrgId: getContactOrgId(state.portalsBlock),
  isFullAuthenticated: state.authentication.loginData.isFullAuthenticated,
  isLoading: state.portalsBlock.isLoading,
  isCompanyListReqCompleted: state.portalsBlock.requestCompleted,
});

const mapDispatchToProps = {
  checkNiudStatus,
  setFormErrors,
  clearApiError,
  resetState,
  getContactCompanyList,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessCheckNiudStatusMain);
